/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Utils for page payments urls
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.15.0
 */

import { AccessComponentKeyEnum } from '../../../modules/role/constants/guard/guardConstants';
import { guardComponentType } from '../../../modules/role/reducer/guardReducer';
import { ExternalRoutePath } from '../../../routes/constants/externalRoutes';
import { CLIENT_ID, RoutePath } from '../../../routes/constants/routesConstants';
import { stringFormat } from '../../../utils/stringFormat';

export const getPagePaymentsUrl = (guardTypes: guardComponentType, id?: string) =>
    guardTypes[AccessComponentKeyEnum.PagePayments]
        ? (id ? RoutePath.paymentsAccountId.replace(CLIENT_ID, id) : RoutePath.paymentsAccount)
        : (id ? stringFormat(ExternalRoutePath.accountPaymentsId, id) : ExternalRoutePath.accountPayments);

export const getPagePaymentsUrlRegex = (guardTypes: guardComponentType) =>
    guardTypes[AccessComponentKeyEnum.PagePayments]
        ? RoutePath.paymentsAccount
        : ExternalRoutePath.accountPayments;

export const getPagePaymentsAccountIdUrlRegex = (guardTypes: guardComponentType) =>
    guardTypes[AccessComponentKeyEnum.PagePayments]
        ? RoutePath.paymentsAccountId
        : ExternalRoutePath.accountPaymentsId;

export const isPagePaymentsExternalUrl = (guardTypes: guardComponentType) =>
    !guardTypes[AccessComponentKeyEnum.PagePayments];
